import DonutSegment from '../donut-chart/donut-segment';

import { setDefaultOptions } from '../../common';

var RadarSegment = (function (DonutSegment) {
    function RadarSegment(value, options) {
        DonutSegment.call(this, value, null, options);
    }

    if ( DonutSegment ) RadarSegment.__proto__ = DonutSegment;
    RadarSegment.prototype = Object.create( DonutSegment && DonutSegment.prototype );
    RadarSegment.prototype.constructor = RadarSegment;

    return RadarSegment;
}(DonutSegment));

setDefaultOptions(RadarSegment, {
    overlay: {
        gradient: "none"
    },
    labels: {
        distance: 10
    }
});

export default RadarSegment;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/chart/radar-bar-chart/radar-segment.js
// module id = 1948
// module chunks = 29